import type { BedCategory } from 'app/typings';
import { BABY_COT_BED_CATEGORY_ID } from 'app/typings';
import { ROOM_STATUS } from 'app/typings/core/admin/rooms/enum/roomStatus';
import { maxRoomCapacity } from 'app/utils/room';
import { pluralize } from 'app/utils/strings';

import type { HotelRoom } from '../../_types';

export const getRoomCapacityLabel = (
  room: HotelRoom,
  bedCategories?: BedCategory[]
) => {
  const guests = maxRoomCapacity(room.beds, bedCategories ?? []);
  const baby = room.beds?.some((b) => b.categoryId === BABY_COT_BED_CATEGORY_ID)
    ? 1
    : 0;

  const formatGuests = guests ? pluralize(guests, 'guest', 'guests') : null;
  const formatBaby = baby ? pluralize(baby, 'baby', 'babies') : null;

  return formatGuests && formatBaby
    ? `${formatGuests} + ${formatBaby}`
    : formatGuests ?? formatBaby ?? '';
};

export const getRoomStatusLabel = (status: HotelRoom['status']) => {
  switch (status) {
    case ROOM_STATUS.PUBLISHED:
      return 'Published';
    case ROOM_STATUS.DELETED:
      return 'Deleted';
    case ROOM_STATUS.UNPUBLISHED:
    default:
      return 'Unpublished';
  }
};

export const getRoomPath = (room: HotelRoom, isHotelLegacy: boolean) =>
  isHotelLegacy ? `/rooms/legacy/${room.id}` : `/rooms/${room.id}`;
